import DataTable from "../../../components/data-table/data-table";
import { alertcaseColumns } from "../alertcases-columns";

interface IPersonalAlertCasesProps {
  onActionClick?: (action_key: string, rowId: string) => void;
  onBeforeRowClick?: (rowId: string) => Promise<boolean>;
}

const PersonalAlertCases = ({onActionClick, onBeforeRowClick}: IPersonalAlertCasesProps) => {
  return <div className="personalAlertCases">
    <DataTable
      style="compact"
      columns={alertcaseColumns}
      defaultSortDirection="desc"
      defaultSortCol="creation_date"
      dataUrl={{
        url: "alertcases",
        backend: "manager",
        queryString: "personal=True"
      }}
      selectionMode="off"
      onActionClick={onActionClick}
      onBeforeRowClick={onBeforeRowClick}
    />
  </div>;
};

export default PersonalAlertCases;